import React, { useState,useEffect } from "react";

const PaymentTab = ({ handleLayoutChange, selectedLayout, updatePayPalButtonTabData, payPalButtonTabData }) => {
    const [sellerPaypalEmail, setSellerPaypalEmail] = useState(payPalButtonTabData.seller_paypal_email);
    const [paymentButtonType, setPaymentButtonType] = useState(payPalButtonTabData.payment_button_type);
    const [productName, setProductName] = useState(payPalButtonTabData.product_name);
    const [selectedLocalization, setSelectedLocalization] = useState(payPalButtonTabData.localization_type);
    const [showLocalizationDropdown, setShowLocalizationDropdown] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(payPalButtonTabData.currency_type);
    const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
    const [price, setPrice] = useState(payPalButtonTabData.price);
    const [shippingPrice, setShippingPrice] = useState(payPalButtonTabData.shipping_price);
    const [selectedTax, setSelectedTax] = useState(payPalButtonTabData.tax_type);
    const [showTaxDropdown, setShowTaxDropdown] = useState(false);
    const [taxValue, setTaxValue] = useState(payPalButtonTabData.tax_value);
    const [selectedBillingInterval, setSelectedBillingInterval] = useState(payPalButtonTabData.billing_interval);
    const [showBillingIntervalDropdown, setShowBillingIntervalDropdown] = useState(false);
    const [isShowRecurringSubscription, setRecurringSubscription] = useState(Number(payPalButtonTabData.is_show_hecurring_subscription));
    const [selectedDonationType, setSelectedDonationType] = useState(payPalButtonTabData.donation_type);
    const [showDonationTypeDropdown, setShowDonationTypeDropdown] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState(payPalButtonTabData.redirect_url);

    //Handlers Seller Paypal Email Change
    const handleSellerPaypalEmailChange = (event) => {
        const value = event.target.value;
        setSellerPaypalEmail(value);
        updatePayPalButtonTabData("seller_paypal_email", value);
    };

    // Handle Payment Button Type change
    const handlePaymentButtonTypeChange = (event) => {
        setPaymentButtonType(event.target.value);
        updatePayPalButtonTabData("payment_button_type", event.target.value);
    };
    
    ///Handlers Product Name Change
    const handleProductNameChange = (event) => {
        const value = event.target.value;
        setProductName(value);
        updatePayPalButtonTabData("product_name", value);
    };

    //Handle Localization Dropdown Change
    const toggleLocalizationDropdown = () => {
        setShowLocalizationDropdown(!showLocalizationDropdown);
    };
    //Handle Localization Change
    const handleLocalizationSelect = (spacing) => {
        setSelectedLocalization(spacing);
        updatePayPalButtonTabData("localization_type", spacing); 
        setShowLocalizationDropdown(false); 
    };

    //Handle Currency Dropdown Change
    const toggleCurrencyDropdown = () => {
        setShowCurrencyDropdown(!showCurrencyDropdown);
    };
    //Handle Currency Change
    const handleCurrencySelect = (spacing) => {
        setSelectedCurrency(spacing);
        updatePayPalButtonTabData("currency_type", spacing); 
        setShowCurrencyDropdown(false); 
    };

    //Handlers Price Change
    const handlePriceChange = (event) => {
        const value = event.target.value;
        // allow only digits and optional decimal point
        if (/^\d*\.?\d*$/.test(value)) {
            setPrice(value);
        }
        updatePayPalButtonTabData("price", value);
    };

    //Handlers Shipping Price Change
    const handleShippingPriceChange = (event) => {
        const value = event.target.value;
        // allow only digits and optional decimal point
        if (/^\d*\.?\d*$/.test(value)) {
            setShippingPrice(value);
        }
        updatePayPalButtonTabData("shipping_price", value);
    };

    //Handle Tax Dropdown Change
    const toggleTaxDropdown = () => {
        setShowTaxDropdown(!showTaxDropdown);
    };
    //Handle Tax Change
    const handleTaxSelect = (type) => {
        setSelectedTax(type);
        updatePayPalButtonTabData("tax_type", type); 
        setShowTaxDropdown(false); 
    };

    //Handle Billing Interval Dropdown Change
    const toggleBillingIntervalDropdown = () => {
        setShowBillingIntervalDropdown(!showTaxDropdown);
    };
    //Handle BillingInterval Change
    const handleBillingIntervalSelect = (type) => {
        setSelectedBillingInterval(type);
        updatePayPalButtonTabData("billing_interval", type); 
        setShowBillingIntervalDropdown(false); 
    };

    //Handlers Show Recurring Subscription Change
    const handleShowRecurringSubscriptionChange = (e) => {
        const checked = e.target.checked;
        setRecurringSubscription(checked);
        updatePayPalButtonTabData("is_show_hecurring_subscription", checked); 
    };

    //Handlers Tax Value Change
    const handleTaxValueChange = (event) => {
        const value = event.target.value;
        // allow only digits and optional decimal point
        if (/^\d*\.?\d*$/.test(value)) {
            setTaxValue(value);
        }
        updatePayPalButtonTabData("tax_value", value);
    };

    //Handle Donation Type Dropdown Change
    const toggleDonationTypeDropdown = () => {
        setShowDonationTypeDropdown(!showTaxDropdown);
    };
    //Handle Donation Type Change
    const handleDonationTypeSelect = (type) => {
        setSelectedDonationType(type);
        updatePayPalButtonTabData("donation_type", type); 
        setShowDonationTypeDropdown(false); 
    };

    ///Handlers Redirect Url Change
    const handleRedirectUrlChange = (event) => {
        const value = event.target.value;
        setRedirectUrl(value);
        updatePayPalButtonTabData("redirect_url", value);
    };

    //useEffect to load settings
    useEffect(() => {
        if (payPalButtonTabData) {
            setSellerPaypalEmail(payPalButtonTabData.seller_paypal_email || "");
            setPaymentButtonType(payPalButtonTabData.payment_button_type || "");
            setProductName(payPalButtonTabData.product_name || "");
            setSelectedLocalization(payPalButtonTabData.localization_type || "");
            setSelectedCurrency(payPalButtonTabData.currency_type || "");
            setPrice(payPalButtonTabData.price || "");
            setShippingPrice(payPalButtonTabData.shipping_price || "");
            setSelectedTax(payPalButtonTabData.tax_type || "");
            setTaxValue(payPalButtonTabData.tax_value || "");
            setSelectedBillingInterval(payPalButtonTabData.billing_interval || "");
            setRecurringSubscription(payPalButtonTabData.is_show_hecurring_subscription || "");
            setSelectedDonationType(payPalButtonTabData.donation_type || "");
            setRedirectUrl(payPalButtonTabData.redirect_url || "");
        }
    }, [payPalButtonTabData]);

    return (
        <div className="side-baar-layout-tab">
            <span>Payment</span>
            <div className="side-baar-box-header">
                <div className="box-header-row bubble-text">
                    <label>Seller PayPal Email</label>
                    <input type="text" value={sellerPaypalEmail} onChange={handleSellerPaypalEmailChange} placeholder="Type Email..." />
                </div>
                <p>Use only business PayPal accounts.</p>
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row bubble-text side-baar-box-header">
                    <span>Payment Type</span>
                    <div className="card h-100 position-tabe p-0 border-0">
                        <div className="label-box-flex p-0">
                            <label className="card-radio-btn px-0">
                                <input type="radio" name="action_element" className="card-input-element d-none" value="Checkout" onChange={handlePaymentButtonTypeChange} checked={paymentButtonType === "Checkout"}/>
                                <div className="card card-body">
                                    <div className="content_sub mt-0">Checkout</div>
                                </div>
                            </label>
                    
                            <label className="card-radio-btn px-0">
                                <input type="radio" name="action_element" className="card-input-element d-none" value="Donation" onChange={handlePaymentButtonTypeChange} checked={paymentButtonType === "Donation"}/>
                                <div className="card card-body">
                                    <div className="content_sub mt-0">Donation</div>
                                </div>
                            </label>
                            <label className="card-radio-btn px-0">
                                <input type="radio" name="action_element" className="card-input-element d-none" value="Subscription" onChange={handlePaymentButtonTypeChange} checked={paymentButtonType === "Subscription"}/>
                                <div className="card card-body">
                                    <div className="content_sub mt-0">Subscription</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div className="side-baar-box-header">
                    {(paymentButtonType === "Checkout" || paymentButtonType === "Donation" || paymentButtonType === "Subscription") && (
                        <>
                            {(paymentButtonType === "Checkout" || paymentButtonType === "Subscription") && (
                            <>
                                <div className="box-header-row bubble-text">
                                    <label>Product Name</label>
                                    <input type="text" value={productName} onChange={handleProductNameChange} placeholder="Product Name..." />
                                </div>
                            </>
                            )}
                            <div className="box-header-row">
                                <span>Localization</span>
                                <em onClick={toggleLocalizationDropdown}>{selectedLocalization}</em>
                                {showLocalizationDropdown && (
                                    <ul className="dropdown-list">
                                        {['English (United States)', 'English (Australia)', 'English (United Kingdom)', 'English (India)', 'French (France)', 'French (Canada)', 'German'].map((type) => (
                                            <li key={type} onClick={() => handleLocalizationSelect(type)}>
                                                {type}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <div className="box-header-row">
                                <span>Currency</span>
                                <em onClick={toggleCurrencyDropdown}>{selectedCurrency}</em>
                                {showCurrencyDropdown && (
                                    <ul className="dropdown-list">
                                        {['USD', 'EUR', 'GBP', 'CAD', 'AFN', 'DZD', 'AOA'].map((type) => (
                                            <li key={type} onClick={() => handleCurrencySelect(type)}>
                                                {type}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            {paymentButtonType === "Subscription"&& (
                            <>
                                <div className="box-header-row">
                                    <span>Billing Interval</span>
                                    <em onClick={toggleBillingIntervalDropdown}>{selectedBillingInterval}</em>
                                    {showBillingIntervalDropdown && (
                                        <ul className="dropdown-list">
                                            {['Daily', 'Weekly', 'Monthly', 'Yearly'].map((type) => (
                                                <li key={type} onClick={() => handleBillingIntervalSelect(type)}>
                                                    {type}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                <div className="box-header-row">
                                    <span>Recurring Subscription</span>
                                    <div className="form-group">
                                        <input id="open_is_show_recurring_subscription" className="chkbx-toggle" type="checkbox" checked={isShowRecurringSubscription} onChange={handleShowRecurringSubscriptionChange} />
                                        <label for="open_is_show_recurring_subscription"></label>
                                    </div>
                                </div>
                            </>
                            )}

                            {(paymentButtonType === "Checkout" || paymentButtonType === "Subscription") && (
                            <>
                            <div className="box-header-row bubble-text">
                                <label>Price in {selectedCurrency}</label>
                                <input type="text" value={price} onChange={handlePriceChange} placeholder="Type Price..." />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label>Shipping Price in {selectedCurrency}</label>
                                <input type="text" value={shippingPrice} onChange={handleShippingPriceChange} placeholder="Type Shipping Price..." />
                            </div>
                            <div className="box-header-row">
                                <span>Tax Type</span>
                                <em onClick={toggleTaxDropdown}>{selectedTax}</em>
                                {showTaxDropdown && (
                                    <ul className="dropdown-list">
                                        {['None', 'Percentage', 'Fixed'].map((type) => (
                                            <li key={type} onClick={() => handleTaxSelect(type)}>
                                                {type}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <div className="box-header-row bubble-text">
                                <label>Tax Value</label>
                                <input type="text" value={taxValue} onChange={handleTaxValueChange} placeholder="Tax Value..." />
                            </div>
                            </>
                            )}


                            {paymentButtonType === "Donation"&& (
                            <>
                                <div className="box-header-row">
                                    <span>Donation Type</span>
                                    <em onClick={toggleDonationTypeDropdown}>{selectedDonationType}</em>
                                    {showDonationTypeDropdown && (
                                        <ul className="dropdown-list">
                                            {['Optional', 'Fixed'].map((type) => (
                                                <li key={type} onClick={() => handleDonationTypeSelect(type)}>
                                                    {type}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </>
                            )}
                        </>
                    )}
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row bubble-text">
                    <input type="text" value={redirectUrl} onChange={handleRedirectUrlChange} placeholder="Redirect URL..." />
                </div>
                <p>After successful transaction.</p>
            </div>
        </div>
    );
};

export default PaymentTab;